import { countryCodes } from '@app/dev/constants/countryPhoneCodes';
import Dropdown from '@common/components/dropdown';
import NumericInput from '@common/components/numericInput';
import { useTranslation } from '@common/hooks/translation';
import React from 'react';

import './style.scss';
import Config from '@app/dev/config/main';

export const PhoneFields = ({
  name, value, onChange, errorMessage, placeHolder, maxLength = 15, customCode,
}) => {
  const t = useTranslation();
  const phoneCodes = new Set([...countryCodes.map((item) => item)]);

  return (
    <>
      <div className="popup-txt">
        {' '}
        {t(name)}
      </div>
      <div className="input-row">
        {customCode
          ? (
            <input
              type="text"
              className="custom-input"
              readOnly
              value={customCode}
            />
          )
          : (
            <Dropdown
              className="code-select"
              value={value.code}
              onChange={(option) => onChange({
                ...value,
                code: option.value,
              })}
              options={[...phoneCodes].map((item) => ({
                value: item.phoneCode,
                name: `${item.phoneCode}${Config.registrationFormConfigs.enableCountryNameForPhoneCode ? ` ${item.countryName}` : ''}`,
                countryAlias: item.countryAlias,
                flagAlias: item.flagAlias,
              })) || []}
            />
          )}
        <NumericInput
          maxLength={maxLength - value.code.length}
          key={name}
          className="numeric-input"
          value={value.phone}
          placeholder={placeHolder}
          onChange={(item) => onChange({
            ...value,
            phone: item,
          })}
        />

      </div>
      {!!errorMessage && <div className="error-message">{t(errorMessage)}</div>}
    </>
  );
};
